/* eslint-disable react/prop-types */
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { useAppContext } from 'providers/AppProvider';
import { TooltipComponent } from 'echarts/components';
import { PieChart } from 'echarts/charts';
import {
  CanvasRenderer
  // SVGRenderer,
} from 'echarts/renderers';
echarts.use([TooltipComponent, PieChart, CanvasRenderer]);
import styled from '@emotion/styled';
import React from 'react';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Button from 'components/base/Button';
import { hrmsPaths } from 'constants/pagePath';

const CustomAlert = styled(Alert)`
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-weight: 400;
  font-size: 0.875rem;
  display: flex;
  padding: 6px 16px;
`;

const IconBox = styled('div')`
  margin-right: 6px;
  padding: 7px 0px;
  display: flex;
  font-size: 22px;
  opacity: 0.9;
  display: 'flex';
  align-items: center;
`;
const getDefaultOptions = (getThemeColor, countData) => ({
  color: [getThemeColor('warning'), getThemeColor('secondary')],

  tooltip: {
    trigger: 'item',
    padding: [7, 10],
    backgroundColor: getThemeColor('warning-100'),
    borderColor: getThemeColor('warning-100'),
    textStyle: { color: getThemeColor('dark') },
    borderWidth: 1,
    transitionDuration: 0,
    formatter: params => `<strong>${params.name}:</strong> ${params.percent}%`
  },
  legend: { show: false },
  series: [
    {
      name: `${countData.totalPercent} %`,
      type: 'pie',
      radius: ['100%', '87%'],
      avoidLabelOverlap: false,
      emphasis: {
        scale: false,
        itemStyle: {
          color: 'inherit'
        }
      },
      itemStyle: {
        borderWidth: 0,
        borderColor: getThemeColor('white')
      },
      label: {
        show: true,
        position: 'center',
        formatter: '{a}',
        fontSize: 10,
        color: getThemeColor('dark')
      },
      data: [
        { value: countData.totalPercent, name: 'Complete' },
        { value: countData.remainingPercent, name: 'Pending' }
      ]
    }
  ],
  grid: { containLabel: true }
});
const IncompleteDetailAlert = ({ percentage, employee_id }) => {
  const { getThemeColor } = useAppContext();

  return (
    <CustomAlert className="bg-warning-100 border px-3 py-2 border-warning text-warning w-100 flex-column flex-sm-row justify-content-sm-between align-items-sm-center">
      <div className="d-flex">
        <IconBox>
          <ReactEChartsCore
            echarts={echarts}
            option={getDefaultOptions(getThemeColor, {
              totalPercent: percentage,
              remainingPercent: 100 - percentage
            })}
            style={{ height: '40px', width: '40px' }}
          />
        </IconBox>
        <div className={`py-1 fs-9 w-100`}>
          {/* {iconPercent} */}
          <p className={`fs-8 fw-bold mb-0 mb-2 fs-8 fw-medium `}>
            Employee setup is incomplete
          </p>
          <div className="d-flex justify-content-between align-items-center">
            <small className="fs-9 fw-normal lh-base">
              <b>Attention:</b> It appears that some required information is
              missing. Please complete all sections to ensure employee details
              are up to date.
            </small>
          </div>
        </div>
      </div>
      <div className="d-flex flex-end-sm-center ms-4 ms-sm-0">
        <Link to={`${hrmsPaths.employee.update(employee_id)}`}>
          <Button className="font-outfit p-2 px-3 fs-9" variant="warning">
            Complete Now
          </Button>
        </Link>
      </div>
    </CustomAlert>
  );
};

export default IncompleteDetailAlert;
